import React, { createContext } from 'react';
import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import EventIcon from '@mui/icons-material/Event';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import LinearScaleOutlinedIcon from '@mui/icons-material/LinearScaleOutlined';
import NotesIcon from '@mui/icons-material/Notes';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ShortTextOutlinedIcon from '@mui/icons-material/ShortTextOutlined';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';

import { getConfig } from './config';

/**
 * @description base URL for mock server
 */
export const getBaseUrl = () => getConfig().baseUrl;

/**
 * @description End point for Login
 */
export const LOGIN_ENDPOINT = '/login';

/**
 * @description End point for Filters
 */
export const FILTERS_ENDPOINT = '/filters';

/**
 * @description End point for Levels
 */
export const LEVELS_ENDPOINT = '/levels';

/**
 * @description End point for Skills
 */
export const SKILLS_ENDPOINT = '/skills';

/**
 * @description End point for HR Reports
 */
export const HR_REPORTS_ENDPOINT = '/reports/hr';

/**
 * @description End point for Agencies
 */
export const PANEL_REPORTS_ENDPOINT = '/reports/panel';

/**
 * @description End point for Departments
 */
export const DEPARTMENTS_ENDPOINT = '/departments';

/**
 * @description End point for Reports
 */
export const REPORTS_ENDPOINT = '/reports';

/**
 * @description End point for Dashboard
 */
export const DASHBOARD_ENDPOINT = '/dashboard';

/**
 * @description End point for CANDIDATE
 */
export const CANDIDATE_ENDPOINT = '/candidate';
/**
 * @description End point for CANDIDATES
 */
export const CANDIDATES_ENDPOINT = '/candidates';

/**
 * @description End point for Positions
 */
export const POSITIONS_ENDPOINT = '/positions';

/**
 * @description End point for Teams
 */
export const TEAMS_ENDPOINT = '/teams';

/**
 * @description End point for Streams
 */
export const STREAMS_ENDPOINT = '/streams';

/**
 * @description End point for Templates
 */
export const TEMPLATES_ENDPOINT = '/templates';

/**
 * @description End point for Templates API
 */
export const TEMPLATES_ENDPOINT_API = '/template';

/**
 * @description End point for Tasks
 */
export const TASKS_ENDPOINT = '/tasks';

/**
 * @description End point for Campus
 */
export const CAMPUS_ENDPOINT = '/campus';

/**
 * @description End point for calendar
 */
export const CALENDAR_EVENTS_ENDPOINT = '/calendarEvents';

/**
 * @description End point for user login
 */
export const USER_LOGIN_ENDPOINT = '/login';

/**
 * @description End point for user logout
 */
export const USER_LOGOUT_ENDPOINT = '/logout';

/**
 * @description End point for user access token
 */
export const ACCESS_TOKEN_ENDPOINT = '/refresh';

/**
 * @description End point for Employees
 */
export const EMPLOYEE_ENDPOINT = '/employees';

/**
 * @description End point for Applications
 */
export const APPLICATIONS_ENDPOINT = '/applications';

/**
 * @description End point for Applications new view
 */
export const APPLICATIONS_BETA_ENDPOINT = '/applications-beta';

/**
 * @description End point for Referrals
 */
export const REFERRALS_ENDPOINT = '/referrals';

/**
 * @description End point for My Open Position
 */
export const MY_OPEN_POSITIONS_ENDPOINT = '/my-open-positions';
export const TOTAL_OPEN_POSITIONS_ENDPOINT = '/total-open-positions';

/**
 * @description End point for settings
 */
export const SETTINGS_ENDPOINT = '/settings';

/**
 * @description End point for master invite template
 */
export const INVITE_TEMPLATE_ENDPOINT = '/invite-templates';

/**
 * @description End point for locations
 */
export const LOCATIONS_ENDPOINT = '/locations';

/**
 * @description End point for interview locations
 */
export const INTERVIEW_LOCATIONS_ENDPOINT = '/interview-location';

/**
 * @description End point for config
 */
export const CONFIG_ENDPOINT = '/configs';

/**
 * @description End point for letterhead
 */
export const LETTERHEAD_ENDPOINT = '/letterhead';

/**
 * @description End point for Application details board
 */
export const APPLICATIONS_DETAILS_ENDPOINT = '/applications-details';

/**
 * @description End point for Application Reports
 */
export const APPLICATION_OVERVIEW_ENDPOINT = '/application-overview';

/**
 * @description End point for Interviews
 */
export const INTERVIEWS_ENDPOINT = '/interviews';
export const PREVIOUS_INTERVIEWS_ENDPOINT = '/previous-interviews';

/**
 * @description End point for Interviews
 */
export const CALENDAR_ENDPOINT = '/calendar';

/**
 * @description get all organization calendars
 */
export const CALENDARS_ENDPOINT = '/calendars';

export const TABULAR_EVENTS_ENDPOINT = '/calendar/table';

/**
 * @description End point for Users
 */
export const USERS_ENDPOINT = '/users';

/**
 * @description End point for Events
 */
export const EVENTS_ENDPOINT = '/events';

/**
 * @description End point for Resume Screening
 */
export const RESUME_SCREENING = '/resume-screening';

/**
 * @description End point for Pre Screening
 */
export const PRE_SCREENING = '/pre-screening';

/**
 * @description End point for Campus Hiring
 */
export const CAMPUS_HIRING = '/campus-hiring';

/**
 * @description End point for the Team Requirements
 */

export const TEAM_REQUIREMENTS_END_POINT = '/requirements';

/**
 * @description retry limit for component import
 */
export const ALLOWED_RETRY_LIMIT = 5;

/**
 * @description End point for positing Resume
 */
export const RESUME_POST_ENDPOINT = 'https://www.googleapis.com/upload/drive/v3/files';

/**
 * @description End point for CAPTCHA_TOKEN
 */
export const CAPTCHA_ENDPOINT = '/driveToken';

/**
 * @description End point for Agencies
 */
export const AGENCIES_ENDPOINT = '/agencies';

/**
 * @description End point for application duplicate check
 */
export const DUPLICATE_CHECK_ENDPOINT = '/applicants/check-duplicate';
/**
 * @description End point for applicant details page
 */
export const APPLICANT_DETAILS_ENDPOINT = '/applicants-details';

/**
 * @description End point for applicant page
 */
export const APPLICANT_ENDPOINT = '/applicant';
/**
 * @description End point for File Upload URL
 */
export const FILE_UPLOAD = '/file-upload-url';

/**
 * @description End point for getting singed resume url
 */
export const FILE = '/file';

/**
 * @description End point for service configurations auth tokens
 */
export const SERVICES_AUTH_TOKEN_ENDPOINT = '/generate-auth-token';

/**
 * @description End point for service configurations refresh tokens
 */
export const SERVICE_CONFIGURATIONS_REFRESH_ENDPOINT = '/refresh-token';

/**
 * @description End point for service configurations refresh tokens
 */
export const CALENDAR_SERVICE_CONFIGURATIONS_REFRESH_ENDPOINT = '/calender-refresh-token';

/**
 * @description End point for service configurations refresh tokens
 */
export const ORGANIZATION_ENDPOINT = '/organization';
export const ORGANIZATION_VIEW_ENDPOINT = '/organisation-view';

/**
 * @description Endpoint for Getting Hr's Theme colors
 */
export const COLORS_ENDPOINT = '/colors';

/**
 * @description Endpoint for Hr's Color Code Configuration
 */
export const USEREVENT_COLOR_ENDPOINT = '/usereventcolor';

/**
 * @description End point for the Panel
 */
export const PANEL_END_POINT = '/position-panel';

/**
 * @description End point for the Panel
 */
export const PANEL_RESOURCE_END_POINT = '/panel';

/**
 * @description End point for the Panel
 */
export const PANEL_SUGGEST_END_POINT = '/suggest-panel';

/**
 * @description End point for Teams
 */
export const PANELS_ENDPOINT = '/panels';

/**
 * @description End point for Access Denied
 */
export const ACCESS_DENIED_ENDPOINT = '/403';

/**
 * @description End point for Calendar Settings
 */
export const USER_SETTINGS_ENDPOINT = '/user-settings';

/**
 * @description End point for offline interview rooms
 */

export const OFFLINE_ROOMS_ENDPOINT = '/rooms';

/**
 * @description End point for notes
 */
export const NOTES_ENDPOINT = '/notes';
/* *
@description End point for careers page it will be append with slug /careers/slug
 */

export const CAREERS_ENDPOINT = '/careers';
export const CANDIDATE_PORTAL_ENDPOINT = '/career';

/**
 * @description End point for careers page it will be append with slug /careers/slug
 */

export const APPLY = '/apply';

export const PANEL_PREFERRED_SLOT_ENDPOINT = '/panel-preferred-timeslot';

export const ORG_PREFERRED_SLOT_ENDPOINT = '/org-preferred-timeslot';

export const USERS_APIKEY_ENDPOINT = '/users/apikey';

/**
 * @description End point for careers page it FETCH THE JOB DETAILS
 */

export const POSITION_DETAILS_END_POINT = '/website/positions';

/**
 * @description End point for careers page it FETCH THE JOB DETAILS
 */

export const CAREERS_FORM_SUBMIT = '/website/applications';

/**
 * captcha unique key Enterprise only
 */

export const getCaptchaSiteKey = () => getConfig().careerCaptchaKey;
/**
 * @description constants for displaying error
 */
export const LENGTH_ERROR = '* text limit exceed';
export const EMPTY_ERROR = '* must be non empty';
export const TIME_ERROR = '* must be greater then current time';
export const MESSAGE_ERROR = '* must contain some message';
export const EMAIL_ERROR = '* must be of type email';
export const PHONE_NUMBER_ERROR = '* invalid number';
export const NOT_NEGATIVE = '* must be positive';
export const CHARACTER_LIMIT_EXCEEDS = 'max character limit exceeds';
export const LINK_ERROR = '* must be of type link';
export const GITHUB_LINK_ERROR = '* link must be of type https://github.com/...';
export const LINKEDIN_LINK_ERROR = '* link must be of type https://www.linkedin.com/...';
export const SELECT_ERROR = '* select field';
export const UPSTREAM_INVALID_TOKEN_MESSAGE = 'The access token is invalid or has expired';
export const INTERVIEW_CONFLICT_MESSAGE = 'Interviewer have conflicting interview';

/**
 * @description constant for maximum length of characters in the editor
 */
export const MAX_CHARACTER_LIMIT = 15000;

/**
 * regex for email and links validation for form fields of apply to a position
 */
export const EMAIL_REGEX = '^[a-z][a-z0-9-]*[.]?[a-z0-9-]+@[a-z0-9-]+[.]{1}[a-z]+';
export const GITHUB_REGEX = /^https:\/\/github.com\/[a-zA-Z0-9-_]+/;
export const LINKEDIN_REGEX = /^https:\/\/www.linkedin.com\/[a-zA-Z0-9-_]+/;
export const FILTER_NUMBER_REGEX = /[+-]?\d+(?:\.\d+)?/;

export const ALL_DATA_LIMIT = 0;

export const getAuthClientID = () => getConfig().googleClientId;
export const getFaroAppName = () => getConfig().faroAppName || '';
export const getFaroAppURL = () => getConfig().faroUrl || '';

export const LOGGED_IN_USER_INFO = 'loggedInUserInfo';

export const PATH_KEY = 'path';

// Holds the orgID requested via a shared link's `?orgID=` query param so the
// login/refresh flow can log the user into that specific organisation.
export const TARGET_ORG_ID_KEY = 'targetOrgId';

export const ErrorTypes = {
  simple: 'simple',
  popOver: 'popOver',
  alert: 'alert',
  custom: 'custom',
};

export const TITLES = {
  HIRING_MOTION: 'Hiring Motion',
  PAGE_NOT_FOUND: '404 Page Not Found',
  HR_REPORTS: 'HR Reports',
  DASHBOARD: 'Dashboard',
  POSITIONS: 'Positions',
  APPLICATIONS_BETA: 'Applications (Beta)',
  APPLICATIONS: 'Applications',
  APPLICATION_OVERVIEW: 'Applications Overview',
  REFERRALS: 'Referrals',
  CALENDAR: 'Interviews',
  RESUME_SCREENING: 'Resume Screening',
  PRE_SCREENING: 'HR Screening',
  TEAMS: 'Teams',
  REQUIREMENT: 'Requirement',
  MY_OPEN_POSITIONS: 'My Open Positions',
  TOTAL_OPEN_POSITIONS: 'Total Open Positions',
  USERS: 'Users',
  LEVELS: 'Levels',
  SKILLS: 'Skills',
  STREAMS: 'Streams',
  TEMPLATES: 'Templates',
  AGENCIES: 'Agencies',
  LOGIN: 'Login',
  INTERVIEWS: 'My Interviews',
  APPLICATIONS_DETAILS: 'Applications Details',
  SETTINGS: 'Settings',
  PANEL_REPORTS: 'Panel Reports',
  GENERAL_SETTINGS: 'General Settings',
  APPLICANT_DETAILS: 'Applicant Details',
  TABULAR_CALENDAR: 'Interviews',
  PANELS: 'Panels',
  ACCESS_DENIED: '403 Access Denied',
  USER_SETTINGS: 'User Settings',
  REPORTS: 'Reports',
};

export const SECTOR_1 =
  'ZopSmart Office, 2078, 24th Main Rd, Vanganahalli, 1st Sector, HSR Layout, Bengaluru, Karnataka 560102, India';

export const SECTOR_2 =
  'ZopSmart, 24th Main Rd, 22nd Cross Rd, Parangi Palaya, Sector 2, Bengaluru, Karnataka 560102';

export const NOIDA_OFFICE =
  'Sharkspace Coworking, A-135, 2nd Floor, A Block, Sector 63, Noida, Uttar Pradesh 201301';

export const ROLES = {
  TENANT_OWNER: 'TENANT_OWNER',
  ADMIN: 'ADMIN',
  HIRING_MANAGER: 'HIRING MANAGER',
  HR: 'HR',
  USER: 'USER',
  AGENCY: 'AGENCY',
  SUPER_ADMIN: 'SUPER ADMIN',
  CANDIDATE: 'CANDIDATE',
};

export const ERROR_MESSAGE = 'Oops! Something went wrong please try again later.';

export const NOTICE_PERIOD_OPTIONS = [
  '15 days',
  '1 month',
  '45 days',
  '2 months',
  '3 months',
  'Serving',
  'Immediate',
];

export const ROUND_STATUS = [
  'SCHEDULED',
  'FEEDBACK PENDING',
  'RESULT PENDING',
  'PASS',
  'INTERVIEW CANCELED',
  'NEW',
  'PENDING INTERVIEW',
  'PENDING',
];

export const ROUND_RESPONSE = {
  'ROUND 1': '1st',
  'ROUND 2': '2nd',
  'ROUND 3': '3rd',
  'ROUND 4': '4th',
  'ROUND 5': '5th',
  'ROUND 6': '6th',
};

export const ROUND_NAME = [
  'HR SCREENING',
  'HR INTERVIEW',
  'SCREENING ROUND',
  'ROUND 1',
  'ROUND 2',
  'ROUND 3',
  'ROUND 4',
  'ROUND 5',
  'ROUND 6',
  'ACKNOWLEDGMENT & CONSENT',
];

export const COLORS_OPTIONS_MAP = new Map([
  // 🟠 Ongoing / In-Progress — Orange
  ['NEW', '#DE7903'],
  ['PENDING', '#DE7903'],
  ['PENDING INTERVIEW', '#DE7903'],
  ['SCHEDULED', '#DE7903'],
  ['INTERVIEW SCHEDULED', '#DE7903'],
  ['PRE SCHEDULED', '#DE7903'],
  ['PROCESSING', '#DE7903'],
  ['RESULT PENDING', '#DE7903'],
  ['FEEDBACK PENDING', '#DE7903'],
  ['SCREENING PENDING', '#DE7903'],
  ['ON HOLD', '#8A99AD'],
  ['DUPLICATE', '#DE7903'],
  ['HR SCREENING', '#DE7903'],
  ['HR INTERVIEW', '#DE7903'],

  // 🟢 Pass / Success — Green
  ['PASS', '#14B35B'],
  ['OFFERED', '#14B35B'],
  ['JOINED', '#14B35B'],
  ['ACTIVE', '#14B35B'],
  ['OPEN', '#14B35B'],

  // 🔴 Fail / Rejected — Red
  ['FAIL', '#B5021D'],
  ['REJECTED', '#B5021D'],
  ['OFFER DECLINED', '#B5021D'],
  ['INTERVIEW FAILED', '#B5021D'],
  ['PRE SCREENING REJECTED', '#B5021D'],
  ['RESUME REJECTED', '#B5021D'],
  ['INTERVIEW CANCELED', '#B5021D'],
  ['DROPPED', '#B5021D'],
  ['INACTIVE', '#B5021D'],

  // ⬛ Closed — Dark
  ['CLOSED', '#313636'],
]);
export const ACCEPT_TYPES =
  'application/pdf, image/*, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .txt';

export const DURATION_TIME = 60 * 60 * 1000;

export const drawerWidth = 19;

export const MOBILE_VIEW_WIDTH = 960;

// This width is for not showing resume when console is open or else will get the known chrome issue
export const SMALL_SCREEN_WIDTH = 980;

export const HTML_HEADING_TAGS = ['<h1>', '<h2>', '<h3>', '<h4>'];

export const ApplicationContext = createContext();

export const AppContext = createContext();

export const AuthContext = createContext();

export const OtherContext = createContext();

export const RESCHEDULE_ERROR_MESSAGE =
  'The interview start time has already passed. Are you sure you want to update it?';

export const SOURCE_FILTER = [
  { id: 1, value: 'REFERRAL' },
  { id: 2, value: 'Careers Page' },
  { id: 3, value: 'AGENCY' },
  { id: 4, value: 'ADMIN' },
  { id: 5, value: 'HR' },
];
export const orgToken =
  'eyJhbGciOiJSUzI1NiIsImtpZCI6IjI4YTQyMWNhZmJlM2RkODg5MjcxZGY5MDBmNGJiZjE2ZGI1YzI0ZDQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJhenAiOiIxNTEzOTIxNTIyOS03b2xhdTI1Z3M5am4xZnVpZzFjZ3U4ZnBucnFlZ2dnci5hcHBzLmdvb2dsZXVzZXJjb250ZW50LmNvbSIsImF1ZCI6IjE1MTM5MjE1MjI5LTdvbGF1MjVnczlqbjFmdWlnMWNndThmcG5ycWVnZ2dyLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwic3ViIjoiMTAyMDkyOTQ4ODM3MzU4OTQzMDQ2IiwiZW1haWwiOiJ2ZXJtYWRpdGkyMDIwQGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJuYmYiOjE3MjgyODEzMTksIm5hbWUiOiJhZGl0aSIsInBpY3R1cmUiOiJodHRwczovL2xoMy5nb29nbGV1c2VyY29udGVudC5jb20vYS9BQ2c4b2NMUnk3THJBQTU4N3NZcW5RUHRLa21NOUtUeXhXbFpoVTdva3U5RzQwcjN3ZUJNX0E0PXM5Ni1jIiwiZ2l2ZW5fbmFtZSI6ImFkaXRpIiwiaWF0IjoxNzI4MjgxNjE5LCJleHAiOjE3MjgyODUyMTksImp0aSI6ImVkZTZhNzllMTlkNmYyZDE0MTBlYjIzYTVmYzI1MGRmNTc1MTk5NzQifQ.lGaD0ptakJTPORdawaWRcBazu8yY16NYo1W-7VH_EkCUisLzE1hsmFR7m7Aiid0krFEAj9BA8Ucdl6DAQA8YMk-sDwj8t1MgTUmErM45aY3UvYG7VLZaiWp9QdLvRoMML8-GfoRJ5SW8oAfXz5FmSYMpIBV8con5H0GUixR_rfEEYPXO0A1__iUgsVW4XwN4n3p_u_lLrpQmvo5WQBR4He0SsejGmVHarYie3S5NJzw6I8ZimGiBgF8DKK4VILVXYSBjPGqIwIt3JwCx4jLeOwtdLwjc2wq6DuP5y7DmglWgGf8ys9GQH6BvkXVQFlAqjtqmf_LHEnBT0JWF6Hg6dg';

export const BULK_UPLOAD_CHUNKSIZE = 1;

export const offerStatus = {
  ACTIVE: 'ACTIVE',
  REVOKED: 'REVOKED',
};

export const QUESTION_TYPES = [
  'NUMBER',
  'TEXT',
  'DROP DOWN',
  'PARAGRAPH',
  'MULTIPLE CHOICE',
  'CHECK BOX',
  'LINEAR SCALE',
  'RATING',
  'DATE AND TIME',
  'UPLOAD FILE',
];

export const TEXT_VALIDATIONS = [
  'CONTAINS',
  'DOES NOT CONTAIN',
  'MATCHES',
  'DOES NOT MATCH',
  'EMAIL',
  'URL',
];
export const NUMBER_VALIDATION = ['MIN NUMBER', 'MAX NUMBER'];
export const LENGTH_VALIDATION = ['MINIMUM CHARACTERS', 'MAXIMUM CHARACTERS'];
export const PARAGRAPH_VALIDATION = ['LENGTH'];
export const PARAGRAPH_VALIDATION_SELECTOR = {
  LENGTH: LENGTH_VALIDATION,
};

export const LINEAR_SCALE_START = [0, 1];
export const LINEAR_SCALE_END = [2, 3, 4, 5, 6, 7, 8, 9, 10];

export const RATING = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const RATING_TYPE = [
  { label: FavoriteBorderIcon, value: <FavoriteBorderIcon />, name: 'HEART' },
  { label: StarOutlineIcon, value: <StarOutlineIcon />, name: 'STAR' },
  { label: ThumbUpOffAltIcon, value: <ThumbUpOffAltIcon />, name: 'THUMBS UP' },
];

// ? upload file validations
export const fileTypes = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  txt: 'text/plain',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
};
export const maxFilesOptions = [1];
export const fileSizeOptions = {
  '1 MB': 1024 * 1024,
  '5 MB': 5 * 1024 * 1024,
  '10 MB': 10 * 1024 * 1024,
  '15 MB': 15 * 1024 * 1024,
};
export const customErrorMap = {
  savePreviousQuestionError: 'Please save the previous question before proceeding.',
};
export const QUESTION_STRUCTURE = {
  'DROP DOWN': {
    fieldName: '',
    fieldType: 'DROP DOWN',
    dropDownOptions: [''],
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
  TEXT: {
    fieldName: '',
    fieldType: 'TEXT',
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
  NUMBER: {
    fieldName: '',
    fieldType: 'NUMBER',
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
  'MULTIPLE CHOICE': {
    fieldName: '',
    fieldType: 'MULTIPLE CHOICE',
    multipleChoiceOptions: [''],
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
  'CHECK BOX': {
    fieldName: '',
    fieldType: 'CHECK BOX',
    checkBoxOptions: [''],
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
  'LINEAR SCALE': {
    fieldName: '',
    fieldType: 'LINEAR SCALE',
    linearScaleValidation: {
      minScale: 1,
      maxScale: 5,
      minScaleLabel: '',
      maxScaleLabel: '',
    },
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
  RATING: {
    fieldName: '',
    fieldType: 'RATING',
    ratingValidation: {
      scaleLimit: 5,
      ratingType: 'STAR',
    },
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
  'DATE AND TIME': {
    fieldName: '',
    fieldType: 'DATE AND TIME',
    dateTimeValidation: {
      needDate: false,
      needTime: false,
    },
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
  'UPLOAD FILE': {
    fieldName: '',
    fieldType: 'UPLOAD FILE',
    uploadFileValidation: {
      maxFileSize: 1024 * 1024,
      allowSpecificType: false,
      allowedFileTypes: [],
    },
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
  PARAGRAPH: {
    fieldName: '',
    fieldType: 'PARAGRAPH',
    required: false,
    isSensitive: false,
    isAgencyMandatory: false,
    isReferralMandatory: false,
  },
};

export const QUESTION_VALIDATION = {
  TEXT: {
    regexpType: 'CONTAINS',
    pattern: '',
  },
  NUMBER: {
    min: '0',
    max: '0',
  },
  PARAGRAPH: {
    validationType: 'LENGTH',
    validationSubType: 'MINIMUM CHARACTERS',
    charCount: '0',
  },
};
export const QUESTION_VALIDATION_TYPE = {
  TEXT: 'regexpValidation',
  NUMBER: 'numberValidation',
  PARAGRAPH: 'paragraphValidation',
};

export const validateFormData = (
  data,
  setError,
  setStateAtIndex,
  index,
  setActive = () => {},
  fieldsArray = []
) => {
  if (!String(data.fieldName).trim()) {
    setError({ error: true, message: 'Please enter the Question' });
    return false;
  }
  // console.log('## validation', fieldsArray, data);
  const isDuplicate = fieldsArray.some((question, ind) => {
    return question?.fieldName === data?.fieldName && index !== ind;
  });

  if (isDuplicate) {
    setError({ error: true, message: 'Question already exists!!' });
    return false;
  }
  const updatedData = { ...data };

  switch (data.fieldType) {
    case 'TEXT':
      if (
        !['EMAIL', 'URL'].includes(data?.regexpValidation?.regexpType) &&
        data.regexpValidation &&
        !String(data.regexpValidation.pattern).trim()
      ) {
        setError({ error: true, message: 'Pattern should not be empty for TEXT field' });
        return false;
      }
      break;

    case 'NUMBER':
      if (data.numberValidation) {
        let { min, max } = data.numberValidation;
        if (!String(min).trim() || !String(max).trim()) {
          setError({ error: true, message: 'Min and Max values should not be empty' });
          return false;
        }

        min = Number(min);
        max = Number(max);

        if (max <= min) {
          setError({ error: true, message: 'Max value should be greater than Min value' });
          return false;
        }

        updatedData.numberValidation = { min, max };
      }
      break;

    case 'PARAGRAPH':
      if (data.paragraphValidation) {
        if (!String(data.paragraphValidation.charCount).trim()) {
          setError({ error: true, message: 'Character count should not be empty' });
          return false;
        }
        updatedData.paragraphValidation.charCount = Number(data.paragraphValidation.charCount);
      }
      break;

    case 'DROP DOWN':
      if (!data.dropDownOptions || data.dropDownOptions.some((opt) => !String(opt).trim())) {
        setError({ error: true, message: 'Options should not be empty for DROP DOWN' });
        return false;
      }
      break;

    case 'MULTIPLE CHOICE':
      if (
        !data.multipleChoiceOptions ||
        data.multipleChoiceOptions.some((opt) => !String(opt).trim())
      ) {
        setError({ error: true, message: 'Options should not be empty for MULTIPLE CHOICE' });
        return false;
      }
      break;

    case 'CHECK BOX':
      if (!data.checkBoxOptions || data.checkBoxOptions.some((opt) => !String(opt).trim())) {
        setError({ error: true, message: 'Options should not be empty for CHECK BOX' });
        return false;
      }
      break;

    case 'LINEAR SCALE':
      break; // Only fieldName validation is required

    case 'RATING':
      break; // Only fieldName validation is required

    case 'DATE AND TIME':
      if (!data.dateTimeValidation?.needDate && !data.dateTimeValidation?.needTime) {
        setError({ error: true, message: 'Either Date or Time must be selected' });
        return false;
      }
      break;

    case 'UPLOAD FILE':
      if (
        data.uploadFileValidation?.allowSpecificType &&
        (!data.uploadFileValidation.allowedFileTypes ||
          data.uploadFileValidation.allowedFileTypes.length === 0)
      ) {
        setError({ error: true, message: 'Please select some file type' });
        return false;
      }
      break;

    default:
      setError({ error: true, message: 'Invalid field type' });
      return false;
  }

  // If validation passes, update only the specific index in the state array
  setStateAtIndex((prevState) => {
    const newState = [...prevState]; // Create a copy of the array
    newState[index] = updatedData; // Update the specific index
    return newState; // Return the updated array
  });

  setTimeout(() => setActive(null), 0);

  return true;
};

export const groupedOptions = [
  ['TEXT', 'PARAGRAPH', 'NUMBER'],
  ['MULTIPLE CHOICE', 'CHECK BOX', 'DROP DOWN'],
  ['LINEAR SCALE', 'RATING'],
  ['DATE AND TIME'],
  ['UPLOAD FILE'],
];
export const fieldTypeOptions = [
  { value: 'TEXT', label: 'Text', icon: <ShortTextOutlinedIcon /> },
  { value: 'NUMBER', label: 'Number', icon: <FormatListNumberedIcon /> },
  { value: 'PARAGRAPH', label: 'Paragraph', icon: <NotesIcon /> },
  { value: 'MULTIPLE CHOICE', label: 'Multiple choice', icon: <RadioButtonCheckedIcon /> },
  { value: 'CHECK BOX', label: 'Check box', icon: <CheckBoxOutlinedIcon /> },
  { value: 'DROP DOWN', label: 'Drop down', icon: <ArrowDropDownCircleOutlinedIcon /> },
  { value: 'LINEAR SCALE', label: 'Linear scale', icon: <LinearScaleOutlinedIcon /> },
  { value: 'RATING', label: 'Rating', icon: <StarOutlineIcon /> },
  { value: 'DATE AND TIME', label: 'Date and Time', icon: <EventIcon /> },
  { value: 'UPLOAD FILE', label: 'Upload file', icon: <BackupOutlinedIcon /> },
];

export const fieldTypeMap = (options) =>
  Object.fromEntries(options.map(({ value, label, icon }) => [value, { label, icon }]));

export function isHTML(str) {
  const pattern = /<\/?[a-z][\s\S]*?>/i;
  return pattern.test(str);
}

export const fieldSample = {
  text: 'sample text',
  number: '1',
  rating: '1',
  'linear scale': '1',
  'date and time': '2006-01-02 03:04',
  paragraph: 'sample text',
  'upload file': 'https://resume.com',
  'drop down': 'sample value',
  'check box': 'option1;option 2',
  'multiple choice': 'option1',
  email: 'abc@gmail.com',
  phone: '1234567890',
  name: 'abc',
};

export const SAMPLE_FIELDS = [
  {
    fieldName: 'Current Salary (In LPA)',
    fieldType: 'NUMBER',
    required: true,
    isSensitive: true,
    id: 'a1b2c3d4-9f01-4a2b-8c3d-1e2f3a4b5c6d',
    isInternal: false,
  },
  {
    fieldName: 'Expected Salary (In LPA)',
    fieldType: 'NUMBER',
    required: true,
    isSensitive: true,
    id: 'b2c3d4e5-1a23-4b3c-9d4e-2f3a4b5c6d7e',
    isInternal: false,
  },
  {
    fieldName: 'Notice Period',
    fieldType: 'DROP DOWN',
    dropDownOptions: [
      '15 days',
      '1 month',
      '45 days',
      '2 months',
      '3 months',
      'Serving',
      'Immediate',
    ],
    required: true,
    isSensitive: false,
    id: 'c3d4e5f6-2b34-4c5d-ae5f-3a4b5c6d7e8f',
    isInternal: false,
  },
  {
    fieldName: 'Notice Period End Date',
    fieldType: 'DATE AND TIME',
    dateTimeValidation: {
      needDate: true,
      needTime: false,
    },
    required: false,
    isSensitive: false,
    id: 'd4e5f6a7-3c45-4d6e-bf6a-4b5c6d7e8f90',
    isInternal: false,
  },
  {
    fieldName: 'Resume',
    fieldType: 'UPLOAD FILE',
    uploadFileValidation: {
      maxFileSize: 15728640,
      allowSpecificType: false,
    },
    required: true,
    isSensitive: false,
    id: 'e5f6a7b8-4d56-4e7f-c07b-5c6d7e8f9011',
    isInternal: false,
  },
  {
    fieldName: 'Additional Information',
    fieldType: 'PARAGRAPH',
    required: false,
    isSensitive: true,
    id: 'f6a7b8c9-5e67-4f80-d18c-6d7e8f901122',
    isInternal: false,
  },
];

export const DEFAULT_FIELDS = ['Name', 'Email', 'Phone', 'Resume', 'Additional Information'];

// Default candidate consent/acknowledgment questions added automatically on position
// creation. `isDefault: true` marks them as required system questions - the text and
// "required" flag can still be edited, but they cannot be removed from the list.
export const DEFAULT_ACKNOWLEDGMENT_QUESTIONS = [
  {
    question:
      'I confirm that I have reviewed the Job Description (JD) and understand the role requirements and details provided.',
    required: true,
    isDefault: true,
  },
  {
    question: 'I confirm that I am comfortable with the 5-day Work From Office (WFO) model.',
    required: true,
    isDefault: true,
  },
  {
    question:
      'I confirm that I am comfortable participating in the face-to-face interview process as communicated by the HR team.',
    required: true,
    isDefault: true,
  },
];

// Ensures the default acknowledgment questions are present in a list of consent
// questions without dropping or duplicating any custom questions already on the
// list. Used when creating a position; duplicating one copies the source
// position's questions as they are instead.
export const withDefaultAcknowledgmentQuestions = (existingList = []) => {
  const normalizedExisting = (existingList || []).map((item) =>
    typeof item === 'string' ? { question: item, required: true } : item
  );

  const isSameQuestion = (a, b) => a?.question?.trim().toLowerCase() === b.trim().toLowerCase();

  const defaults = DEFAULT_ACKNOWLEDGMENT_QUESTIONS.map((defaultQuestion) => {
    const match = normalizedExisting.find((item) => isSameQuestion(item, defaultQuestion.question));
    return match ? { ...match, isDefault: true } : { ...defaultQuestion };
  });

  const customQuestions = normalizedExisting.filter(
    (item) =>
      !DEFAULT_ACKNOWLEDGMENT_QUESTIONS.some((defaultQuestion) =>
        isSameQuestion(item, defaultQuestion.question)
      )
  );

  return [...defaults, ...customQuestions];
};

export const CALENDAR_USER_STATUS = {
  userUnknown: 'Unknown',
  userAvailable: 'Available',
  userUnavailable: 'Unavailable',
  interviewConflict: 'InterviewConflict',
};

export const PANEL_PREFERRED_SLOT_STATUS = {
  noRecord: 'NO_RECORD',
  preferredSlot: 'PREFERRED_SLOT',
  notPreferredSlot: 'NOT_PREFERRED_SLOT',
};

export const PANEL_TABLE_COLUMNS_ID = [
  'passed_interviews',
  'failed_interviews',
  'canceled_interviews',
  'declined_interviews',
  'pending_interviews',
  'feedback_pending_interviews',
  'result_pending_interviews',
  'upcoming_interviews',
  'previous_interviews',
  'total_interviews',
];

export const HR_REPORT_TABLE_COLUMNS_ID = [
  'uploaded_application',
  'scheduled_interview',
  'positions',
  'canceled_interview',
];

export const ALLOWED_THRESHOLD_TYPES = ['NUMBER', 'TEXT', 'DROP DOWN', 'LINEAR SCALE', 'RATING'];

export const TEMPLATE_TYPE = [
  'OFFER LETTER',
  'REJECT',
  'ONLINE INVITE',
  'OFFLINE INVITE',
  'JOB DESCRIPTION',
];

export const adminInstructions = [
  {
    title: 'PART A: Create reCAPTCHA Enterprise Site Key',
    steps: [
      'Select GCP Project\nOpen Google Cloud Console and use the project selector to choose the GCP Project that will be used by the career’s website.',
      'Enable reCAPTCHA Enterprise API\nGo to APIs & Services → Library\nSearch for "reCAPTCHA Enterprise API" → Click Enable',
      'Create reCAPTCHA Enterprise Key\nGo to Security → reCAPTCHA Enterprise\nClick "Create key"\nFill in:\n   • Display name\n   • Key type: Score-based\n   • Platform: Web\n   • Allowed domains\nClick Create',
      'Save and Share\nSave the Project ID in Hiring Motion’s General Settings page (Career Page configurations).\nShare the Project ID and reCAPTCHA Site Key with the frontend developer.',
    ],
  },
  {
    title: 'PART B: Grant Project B Service Account Access',
    options: [
      {
        title: 'Option 1: Using Google Cloud Console (UI)',
        steps: [
          'Go to IAM & Admin → IAM\nClick "Grant Access"\nNew principals: {{serviceAccName}}\nAssign role: reCAPTCHA Enterprise Agent (roles/recaptchaenterprise.agent)\nClick Save',
        ],
      },
      {
        title: 'Option 2: Using gcloud CLI (Terminal)',
        steps: [
          'Run these three commands one by one (replace PROJECT_A_ID with your actual Project ID):',
          { type: 'code', content: 'gcloud config set project PROJECT_A_ID' },
          { type: 'code', content: 'gcloud services enable recaptchaenterprise.googleapis.com' },
          {
            type: 'code',
            content: `gcloud projects add-iam-policy-binding PROJECT_A_ID \\
  --member="serviceAccount:{{serviceAccName}}" \\
  --role="roles/recaptchaenterprise.agent"`,
          },
        ],
      },
    ],
  },
];

export const developerInstructions = [
  {
    title: 'Frontend Integration Guide',
    steps: [
      'Load reCAPTCHA Enterprise Script\nAdd the following script to the <head> section of your careers page:\n<script src="https://www.google.com/recaptcha/enterprise.js?render={{RECAPTCHA_SITE_KEY}}"></script>\n\nReplace {{RECAPTCHA_SITE_KEY}} with the actual Site Key provided by the admin (e.g., 6Levsdvsd45b3AAAA45b34nxcknxcnkn3454nbd).',
      "Execute reCAPTCHA on Form Submit\nWhen the user submits the application form, generate a reCAPTCHA token:\n<script>\nfunction handleFormSubmit(e) {\n  e.preventDefault();\n\n  grecaptcha.enterprise.ready(async () => {\n    const token = await grecaptcha.enterprise.execute(\n      '{{RECAPTCHA_SITE_KEY}}', \n      { action: 'form_submit' } \n    );\n\n    // Now submit the form with the token\n    submitApplicationForm(token);\n  });\n}> </script>\n",
      'Frontend Call to Google reCAPTCHA Endpoint\nWhen grecaptcha.enterprise.execute() is called, the browser automatically makes a POST request to Google’s secure endpoint:\nhttps://recaptchaenterprise.googleapis.com/v1/projects/{project-id}/assessments\n\nThis generates a short-lived token based on user interaction and risk analysis. No additional manual fetch is required — the script handles it securely.',
      "Submit Application to Hiring Motion Backend\nAfter obtaining the token, send the application data to the Hiring Motion API:\nPOST {{BASE_URL}}/applications\n\nInclude these required reCAPTCHA headers:\n• G-recaptcha-response: [the token from grecaptcha.enterprise.execute()]\n• g-recaptcha-action: form_submit  (must match the action used in execute)\n• g-recaptcha-key: {{RECAPTCHA_SITE_KEY}}  (the same site key used in the script)\n Example: \n g-recaptcha-response: “CAPTCHA_TOKEN” \n g-recaptcha-action:  “form_submit”\n g-recaptcha-key: “YOUR_SITE_KEY”\n ```\nasync function submitApplicationForm(token) {\n  const formData = { /* your application data */ };\n\n  const response = await fetch('{{BASE_URL}}/applications', {\n    method: 'POST',\n    headers: {\n      'Content-Type': 'application/json',\n      'G-recaptcha-response': token,\n      'g-recaptcha-action': 'form_submit',\n      'g-recaptcha-key': 'RECAPTCHA_SITE_KEY',\n      // other auth headers if needed\n    },\n    body: JSON.stringify(formData),\n  });\n\n  // Handle response\n}\n```",
      'Backend Verification (Handled by Hiring Motion)\nThe Hiring Motion backend will automatically verify the reCAPTCHA token using the Project ID and service account credentials configured by the admin. You do not need to verify the token on the frontend.',
    ],
  },
  {
    title: 'Best Practices',
    steps: [
      '• Always execute reCAPTCHA just before form submission (not on page load)\n• Never expose the secret key on the frontend — only the Site Key is public\n• Test with Google’s test keys during development.',
    ],
  },
];

export const dwdInstructions = [
  {
    title: 'DOMAIN-WIDE DELEGATION INSTRUCTIONS',
    steps: [
      '- Create a Service Account (if not already created)\n\n- Go to Google Cloud Console\n\n- Select your project\n\n- Navigate to IAM & Admin → Service Accounts\n\n- Click Create Service Account\n\n- Give it a name → Create',
      '- Enable Domain-Wide Delegation on the Service Account\n\n- Open the service account\n\n- Go to Details\n\n- Click Show Domain-Wide Delegation\n\n- Check Enable Google Workspace Domain-wide Delegation\n\n- Then save it\n\n- Copy the Client ID (very important)',
      '- Add DWD in Google Workspace Admin Console\n\n- Go to admin.google.com\n\n- Navigate to: Security → Access and data control → API controls\n\n- Open Domain-wide delegation\n\n- Click Add new\n\n- Fill in:\n- Client ID → Paste the service account client ID\n- OAuth scopes → Comma-separated list : 𝗮𝗱𝗺𝗶𝗻.𝗱𝗶𝗿𝗲𝗰𝘁𝗼𝗿𝘆.𝘂𝘀𝗲𝗿.𝗿𝗲𝗮𝗱𝗼𝗻𝗹𝘆, 𝗰𝗮𝗹𝗲𝗻𝗱𝗮𝗿',
    ],
  },
];

/**
 * @description Azure Client ID
 */

export const getAzureClientId = () => getConfig().azureClientId;

/**
 * @description Azure Tenant ID
 */

export const getAzureTenantId = () => getConfig().azureTenantId;
